import { render, staticRenderFns } from "./NfsePrefeituraCreateUpdate.vue?vue&type=template&id=980dd4c4&"
import script from "./NfsePrefeituraCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./NfsePrefeituraCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports